import { WsSalesSolutionAction, WsSalesSolutionAssumption, WsSalesSolutionDeliverableInterface, WsSalesSolutionDependency, WsSalesSolutionItem, WsSalesSolutionMetric, WsSalesSolutionOfferingRoleInterface, WsSalesSolutionRiskInterface, WsSalesSolutionStaticLookupInterface, WsSalesSolutionToolInterface, WsSalesSolutionWorkProductInterface } from '../core';

import { WsSalesSolutionDeliverableClass, WsSalesSolutionWorkProductClass, WsSalesSolutionOfferingRoleClass, WsSalesSolutionToolClass, WsSalesSolutionRiskClass } from '../core-sales';
import { getValue } from '../helpers/item-helpers';




interface WsSalesOfferingsData {
  '$version': string,
  offerings:    WsSalesSolutionItem[],
  actions:      WsSalesSolutionAction[],
  metrics:      WsSalesSolutionMetric[],
  dependencies: WsSalesSolutionDependency[],
  assumptions:  WsSalesSolutionAssumption[],
  deliverables: WsSalesSolutionDeliverableInterface[],
  workProducts: WsSalesSolutionWorkProductInterface[],
  roles:        WsSalesSolutionOfferingRoleInterface[],
  tools:        WsSalesSolutionToolInterface[],
  risks:        WsSalesSolutionRiskInterface[],

  static:       { [ key: string ]: WsSalesSolutionStaticLookupInterface[] }

  /*
  static: {
    acceptanceCriteria
    workProductFormats
    rolesTypes
  }
  */

};




const getChildren = (
  parent:   WsSalesSolutionItem   | WsSalesSolutionAction   | undefined,
  children: WsSalesSolutionItem[] | WsSalesSolutionAction[] | undefined,
  type: string,
  mode?: string
) => {

  const data: WsSalesOfferingsData = {
    '$version': '3.0',
    offerings:    [],
    actions:      [],
    metrics:      [],
    dependencies: [],
    assumptions:  [],
    deliverables: [],
    workProducts: [],
    roles:        [],
    tools:        [],
    risks:        [],
    static:       {}
  };

  if (children && Array.isArray(children) && children.length > 0) {

    children.forEach((child) => { // TODO: child: any


      // offerings
      if (type === 'offerings') {

        const item: WsSalesSolutionItem = child;

        const listItem: WsSalesSolutionItem = {
          id:              item.id,
          parentId:        parent ? parent.id : '',
          name:            item.name,
          description:     item.description       ? item.description     : '', // TODO: replace check with value
          sizeDescription: item.sizeDescription.S ? item.sizeDescription : { S: '', M: '', C: '', VC: '' }, // TODO: replace check with value
          areaId:          item.areaId,
          linkIds:         item.linkIds ? item.linkIds : []
        };

        if (mode === 'admin') {
        } else {
          listItem.selected = item.selected;
          listItem.size     = item.size;
        }

        // expanded
        // items
        // actions
        // dependencies
        // assumption

        data.offerings.push(listItem);
      }


      // actions
      if (type === 'actions') {

        const item: WsSalesSolutionAction = child;

        const listItem: WsSalesSolutionAction = {
          id:            item.id,
          parentId:      parent ? parent.id : '',
          name:          item.name,
          description:   item.description ? item.description : '', // TODO: replace check with value
          effort:        item.effort,
          dependencyIds: item.dependencyIds ? item.dependencyIds : [],
          aepPhase:      item.aepPhase      ? item.aepPhase      : 'Plan', // TODO: replace check with value

          sequential: getValue(item.sequential, true),
          parallel:   getValue(item.parallel,   0)
        };

        if (mode === 'admin') {
        } else {
          listItem.selected = item.selected;
        }

        // expanded
        // actions
        // metrics
        // dependencies
        // assumptions

        data.actions.push(listItem);
      }


      // metrics
      if (type === 'metrics') {

        const item: WsSalesSolutionMetric = child;

        const listItem: WsSalesSolutionMetric = {
          id:       item.id,
          parentId: parent ? parent.id : '',
          name:     item.name,
          effort:   item.effort,
          value:    item.value,

          defaultEffort: getValue(item.defaultEffort, item.effort),
          defaultValue:  getValue(item.defaultValue,  item.value),

          core:     item.core ? true : false
        };



        data.metrics.push(listItem);
      }


      // dependencies
      if (type === 'dependencies') {

        const item: WsSalesSolutionDependency = child;

        const listItem: WsSalesSolutionDependency = {
          id:       item.id,
          parentId: parent ? parent.id : '',
          name:     item.name ? item.name : item.text // TODO: remove text
        };

        data.dependencies.push(listItem);
      }


      // assumptions
      if (type === 'assumptions') {

        const item: WsSalesSolutionAssumption = child;

        const listItem: WsSalesSolutionAssumption = {
          id:       item.id,
          parentId: parent ? parent.id : '',
          name:     item.name ? item.name : item.text // TODO: remove text
        };

        data.assumptions.push(listItem);
      }


      // deliverables
      if (type === 'deliverables') {

        const item: WsSalesSolutionDeliverableClass = child;

        const listItem: WsSalesSolutionDeliverableInterface = {
          id:             item.id,
          parentId:       parent ? parent.id : '',
          name:           item.name,
          description:    item.description,
          format:         item.format,
          documentId:     item.documentId,
          reviewSettings: item.reviewSettings
        };

        data.deliverables.push(listItem);
      }


      // workProducts
      if (type === 'workProducts') {

        const item: WsSalesSolutionWorkProductClass = child;

        const listItem: WsSalesSolutionWorkProductInterface = {
          id:          item.id,
          parentId:    parent ? parent.id : '',
          name:        item.name,
          description: item.description,
          format:      item.format,
          documentId:  item.documentId
        };

        data.workProducts.push(listItem);
      }


      // roles
      if (type === 'roles') {

        const item: WsSalesSolutionOfferingRoleClass = child;

        const listItem: WsSalesSolutionOfferingRoleInterface = {
          id:          item.id,
          parentId:    parent           ? parent.id        : '',
          staticId:    item.staticId    ? item.staticId    : '',
          name:        item.name,
          value:       item.value       ? item.value       : 100,
          team:        item.team        ? item.team        : 'AVANADE',
          location:    item.location    ? item.location    : 'ONSHORE_UK',
          aep:         item.aep         ? item.aep         : {},
          governance:  item.governance  ? item.governance  : false
        };

        data.roles.push(listItem);
      }


      // tools
      if (type === 'tools') {

        const item: WsSalesSolutionToolClass = child;

        const listItem: WsSalesSolutionToolInterface = {
          id:       item.id,
          parentId: parent ? parent.id : '',
          name:     item.name
        };

        data.tools.push(listItem);
      }


      // risks
      if (type === 'risks') {

        const item: WsSalesSolutionRiskClass = child;

        const listItem: WsSalesSolutionRiskInterface = {
          id:          item.id,
          parentId:    parent ? parent.id : '',
          name:        item.name,
          consequence: item.consequence,
          mitigation:  item.mitigation,
          impact:      item.impact,
          probability: item.probability,
          // owner
          comments:    item.comments
        };

        data.risks.push(listItem);
      }


      // children

      // offerings
      const childrenDataOfferings = getChildren(child, child.items, 'offerings', mode);
      dataPush(data, childrenDataOfferings);

      // actions
      const childrenDataActions = getChildren(child, child.actions, 'actions', mode);
      dataPush(data, childrenDataActions);

      // metrics
      const childrenDataMetrics = getChildren(child, child.metrics, 'metrics', mode);
      dataPush(data, childrenDataMetrics);

      // dependencies
      const childrenDataDependencies = getChildren(child, child.dependencies, 'dependencies', mode);
      dataPush(data, childrenDataDependencies);

      // assumptions
      const childrenDataAssumptions = getChildren(child, child.assumptions, 'assumptions', mode);
      dataPush(data, childrenDataAssumptions);

      // deliverables
      const childrenDataDeliverables = getChildren(child, child.children?.filter((c) => c instanceof WsSalesSolutionDeliverableClass), 'deliverables', mode);
      dataPush(data, childrenDataDeliverables);

      // workProducts
      const childrenDataWorkProducts = getChildren(child, child.children?.filter((c) => c instanceof WsSalesSolutionWorkProductClass), 'workProducts', mode);
      dataPush(data, childrenDataWorkProducts);

      // roles
      const childrenDataRoles = getChildren(child, child.children?.filter((c) => c instanceof WsSalesSolutionOfferingRoleClass), 'roles', mode);
      dataPush(data, childrenDataRoles);

      // tools
      const childrenDataTools = getChildren(child, child.children?.filter((c) => c instanceof WsSalesSolutionToolClass), 'tools', mode);
      dataPush(data, childrenDataTools);

      // risks
      const childrenDataRisks = getChildren(child, child.children?.filter((c) => c instanceof WsSalesSolutionRiskClass), 'risks', mode);
      dataPush(data, childrenDataRisks);

    });
  }

  return data;
};




const dataPush = (data: WsSalesOfferingsData, childrenData: WsSalesOfferingsData) => {

  data.offerings.push(...childrenData.offerings);

  data.actions.push(...childrenData.actions);

  data.metrics.push(...childrenData.metrics);

  data.dependencies.push(...childrenData.dependencies);

  data.assumptions.push(...childrenData.assumptions);

  data.deliverables.push(...childrenData.deliverables);

  data.workProducts.push(...childrenData.workProducts);

  data.roles.push(...childrenData.roles);

  data.tools.push(...childrenData.tools);

  data.risks.push(...childrenData.risks);

};



// tranform items to data

const salesOfferingsTransformItemsToData = (items: WsSalesSolutionItem[], mode?: string) => {

  const data: WsSalesOfferingsData = {
    '$version': '3.0',
    offerings:    [],
    actions:      [],
    metrics:      [],
    dependencies: [],
    assumptions:  [],
    deliverables: [],
    workProducts: [],
    roles:        [],
    tools:        [],
    risks:        [],
    static:       {}
  };

  const childrenDataOfferings = getChildren(undefined, items, 'offerings', mode);
  dataPush(data, childrenDataOfferings);

  return data;
};








// const ab: WsSalesSolutionDeliverableClass | WsSalesSolutionWorkProductClass = new WsSalesSolutionDeliverableClass('a');

// if (ab instanceof WsSalesSolutionDeliverableClass) {
//   console.log(ab.acceptanceCriteria);
// }

// if (ab instanceof WsSalesSolutionWorkProductClass) {
//   console.log(ab.acceptanceCriteria);
// }










const createItem = (itemData: any, type: string, options: { mode?: string, selectActions?: boolean }) => {

  if (type === 'offerings') {

    const itemId   = (itemData as WsSalesSolutionItem).id;
    let   itemName = (itemData as WsSalesSolutionItem).name;

    if (itemId === '01H5PM1ZNYZ3BCMPWJWQXWPEC6') {
      // end-user platform
      itemName = 'Modern Workplace';
    }

    if (itemId === '01H5PM1ZP30BXYV44KDE2A614E') {
      // virtualization
      itemName = 'Applications and Infrastructure';
    }

    if (itemId === '01H5PM1ZP54NFDCND4S5XQG68P') {
      // ai
      itemName = 'Data and AI';
    }

    if (itemId === '01H7YPT54GZKS9F7769KAVS5RR') {
      // productivity
      itemName = 'Business Applications';
    }

    const item: WsSalesSolutionItem = {
      id:              itemId,
      name:            itemName,
      description:     (itemData as WsSalesSolutionItem).description       ? (itemData as WsSalesSolutionItem).description     : '', // TODO: replace check with value
      sizeDescription: (itemData as WsSalesSolutionItem).sizeDescription.S ? (itemData as WsSalesSolutionItem).sizeDescription : { S: '', M: '', C: '', VC: '' }, // TODO: replace check with value
      areaId:          (itemData as WsSalesSolutionItem).areaId,
      selected:        (itemData as WsSalesSolutionItem).selected,
      size:            (itemData as WsSalesSolutionItem).size,
      expanded: false,
      linkIds:         (itemData as WsSalesSolutionItem).linkIds ? (itemData as WsSalesSolutionItem).linkIds : [],
    };

    if (options.mode === 'admin') {
      if (itemData.parentId === '') {
        item.expanded = true;
      }
    }

    return item;



  } else if (type === 'actions') {

    const item: WsSalesSolutionAction = {
      id:            (itemData as WsSalesSolutionAction).id,
      name:          (itemData as WsSalesSolutionAction).name,
      description:   (itemData as WsSalesSolutionAction).description ? (itemData as WsSalesSolutionAction).description : '', // TODO: replace check with value
      effort:        (itemData as WsSalesSolutionAction).effort,
      selected:      (itemData as WsSalesSolutionAction).selected,
      dependencyIds: (itemData as WsSalesSolutionAction).dependencyIds ? (itemData as WsSalesSolutionAction).dependencyIds : [],
      aepPhase:      (itemData as WsSalesSolutionAction).aepPhase      ? (itemData as WsSalesSolutionAction).aepPhase      : 'Plan', // TODO: replace check with value

      sequential:    getValue((itemData as WsSalesSolutionAction).sequential, true),
      parallel:      getValue((itemData as WsSalesSolutionAction).parallel,   0),

      expanded: false
    };

    if (options.selectActions) {
      item.selected = true;
    }

    return item;



  } else if (type === 'metrics') {

    const item: WsSalesSolutionMetric = {
      id:     (itemData as WsSalesSolutionMetric).id,
      name:   (itemData as WsSalesSolutionMetric).name,
      effort: (itemData as WsSalesSolutionMetric).effort,
      value:  (itemData as WsSalesSolutionMetric).value,

      defaultEffort: getValue((itemData as WsSalesSolutionMetric).defaultEffort, (itemData as WsSalesSolutionMetric).effort),
      defaultValue:  getValue((itemData as WsSalesSolutionMetric).defaultValue,  (itemData as WsSalesSolutionMetric).value),

      core:   (itemData as WsSalesSolutionMetric).core ? true : false
    };

    return item;



  } else if (type === 'dependencies') {

    const item: WsSalesSolutionDependency = {
      id:   (itemData as WsSalesSolutionDependency).id,
      name: (itemData as WsSalesSolutionDependency).name,
      text: (itemData as WsSalesSolutionDependency).name // TODO: remove text
    };

    return item;



  } else if (type === 'assumptions') {

    const item: WsSalesSolutionAssumption = {
      id:   (itemData as WsSalesSolutionAssumption).id,
      name: (itemData as WsSalesSolutionAssumption).name,
      text: (itemData as WsSalesSolutionAssumption).name // TODO: remove text
    };

    return item;



  } else if (type === 'deliverables') {

    const name = (itemData as WsSalesSolutionDeliverableInterface).name;

    const item: WsSalesSolutionDeliverableClass = new WsSalesSolutionDeliverableClass(`${name}`);

    item.description = (itemData as WsSalesSolutionDeliverableInterface).description ? (itemData as WsSalesSolutionDeliverableInterface).description : ''; // TODO: remove?

    item.format = (itemData as WsSalesSolutionDeliverableInterface).format ? (itemData as WsSalesSolutionDeliverableInterface).format : { id: '', name: 'None' }; // TODO: remove?

    item.documentId  = (itemData as WsSalesSolutionDeliverableInterface).documentId;

    item.reviewSettings = (itemData as WsSalesSolutionDeliverableInterface).reviewSettings;

    

    item.id = (itemData as WsSalesSolutionDeliverableInterface).id; // TODO: set id in constructor

    return item;


  
  } else if (type === 'workProducts') {

    const name = (itemData as WsSalesSolutionWorkProductInterface).name;

    const item: WsSalesSolutionWorkProductClass = new WsSalesSolutionWorkProductClass(`${name}`);

    item.description = (itemData as WsSalesSolutionWorkProductInterface).description ? (itemData as WsSalesSolutionWorkProductInterface).description : ''; // TODO: remove?

    item.format = (itemData as WsSalesSolutionWorkProductInterface).format ? (itemData as WsSalesSolutionWorkProductInterface).format : { id: '', name: 'None' }; // TODO: remove?

    item.documentId  = (itemData as WsSalesSolutionWorkProductInterface).documentId;

    item.id = (itemData as WsSalesSolutionWorkProductInterface).id; // TODO: set id in constructor

    return item;



  } else if (type === 'roles') {

    const name = (itemData as WsSalesSolutionOfferingRoleInterface).name;

    const item: WsSalesSolutionOfferingRoleClass = new WsSalesSolutionOfferingRoleClass({ name: `${name}` });

    // TODO: set id in constructor
    item.id = (itemData as WsSalesSolutionOfferingRoleInterface).id;

    // TODO: set id in constructor
    item.staticId = (itemData as WsSalesSolutionOfferingRoleInterface).staticId ? (itemData as WsSalesSolutionOfferingRoleInterface).staticId : '';

    // TODO: set id in constructor
    item.value = (itemData as WsSalesSolutionOfferingRoleInterface).value ? (itemData as WsSalesSolutionOfferingRoleInterface).value : 100;

    // team
    if ((itemData as WsSalesSolutionOfferingRoleInterface).team) {
      item.team = (itemData as WsSalesSolutionOfferingRoleInterface).team;
    }

    // location
    if ((itemData as WsSalesSolutionOfferingRoleInterface).location) {
      item.location = (itemData as WsSalesSolutionOfferingRoleInterface).location;
    }

    // aep
    if ((itemData as WsSalesSolutionOfferingRoleInterface).aep) {
      item.aep = (itemData as WsSalesSolutionOfferingRoleInterface).aep;
    } else {
      item.aep = {};
    }

    // governance
    if ((itemData as WsSalesSolutionOfferingRoleInterface).governance) {
      item.governance = (itemData as WsSalesSolutionOfferingRoleInterface).governance;
    } else {
      item.governance = false;
    }

    return item;



  } else if (type === 'tools') {

    const name = (itemData as WsSalesSolutionToolInterface).name;

    const item: WsSalesSolutionToolClass = new WsSalesSolutionToolClass(`${name}`);

    item.id = (itemData as WsSalesSolutionToolInterface).id; // TODO: set id in constructor

    return item;



  } else if (type === 'risks') {

    const name = (itemData as WsSalesSolutionRiskInterface).name;

    const item: WsSalesSolutionRiskClass = new WsSalesSolutionRiskClass(`${name}`);

    item.id = (itemData as WsSalesSolutionRiskInterface).id; // TODO: set id in constructor

    item.consequence = (itemData as WsSalesSolutionRiskInterface).consequence;
    item.mitigation  = (itemData as WsSalesSolutionRiskInterface).mitigation;
    item.impact      = (itemData as WsSalesSolutionRiskInterface).impact;
    item.probability = (itemData as WsSalesSolutionRiskInterface).probability;
    // owner
    item.comments    = (itemData as WsSalesSolutionRiskInterface).comments;

    return item;



  } else {
    return undefined;
  }
};




const getItemsFromData = (data: WsSalesOfferingsData, parentId: string, type: string): WsSalesSolutionItem[] | WsSalesSolutionAction[] | WsSalesSolutionMetric[] | WsSalesSolutionDependency[] | WsSalesSolutionAssumption[] => {

  if (type === 'offerings') {
    return data.offerings.filter((offering: WsSalesSolutionItem) => offering.parentId === parentId);

  } else if (type === 'actions') {
    return data.actions.filter((action: WsSalesSolutionAction) => action.parentId === parentId);

  } else if (type === 'metrics') {
    return data.metrics.filter((metric: WsSalesSolutionMetric) => metric.parentId === parentId);

  } else if (type === 'dependencies') {
    return data.dependencies.filter((dependency: WsSalesSolutionDependency) => dependency.parentId === parentId);

  } else if (type === 'assumptions') {
    return data.assumptions.filter((assumption: WsSalesSolutionAssumption) => assumption.parentId === parentId);

  } else if (type === 'deliverables') {
    return data.deliverables ? data.deliverables.filter((deliverable: WsSalesSolutionDeliverableInterface) => deliverable.parentId === parentId) : [];

  } else if (type === 'workProducts') {
    return data.workProducts ? data.workProducts.filter((workProduct: WsSalesSolutionWorkProductInterface) => workProduct.parentId === parentId) : [];

  } else if (type === 'roles') {
    return data.roles ? data.roles.filter((role: WsSalesSolutionOfferingRoleInterface) => role.parentId === parentId) : [];

  } else if (type === 'tools') {
    return data.tools ? data.tools.filter((tool: WsSalesSolutionToolInterface) => tool.parentId === parentId) : [];

  } else if (type === 'risks') {
    return data.risks ? data.risks.filter((risk: WsSalesSolutionRiskInterface) => risk.parentId === parentId) : [];

  } else {
    return [] as WsSalesSolutionItem[];
  }
};




const getItems = (data: WsSalesOfferingsData, parentId: string, type: string, options: { mode?: string, selectActions?: boolean }): WsSalesSolutionItem[] | WsSalesSolutionAction[] | WsSalesSolutionMetric[] | WsSalesSolutionDeliverableClass[] | WsSalesSolutionWorkProductClass[] | WsSalesSolutionOfferingRoleClass[] | WsSalesSolutionToolClass[] | WsSalesSolutionRiskClass[] | WsSalesSolutionDependency[] | WsSalesSolutionAssumption[] | undefined => {

  const items: any[] = [];


  getItemsFromData(data, parentId, type).forEach((itemData: any) => {

    const item = createItem(itemData, type, options);

    if (item) {


      if (type === 'offerings') {

        // items
        (item as WsSalesSolutionItem).items = getItems(data, item.id, 'offerings', options) as WsSalesSolutionItem[];
      }


      if (type === 'offerings' || type === 'actions') {

        if (type === 'actions') {

          // metrics
          (item as WsSalesSolutionAction).metrics = getItems(data, item.id, 'metrics', options) as WsSalesSolutionMetric[];

          // children
          const itemChildren: (WsSalesSolutionDeliverableClass | WsSalesSolutionWorkProductClass | WsSalesSolutionOfferingRoleClass | WsSalesSolutionToolClass | WsSalesSolutionRiskClass )[] = [];

          // deliverables
          const del = getItems(data, item.id, 'deliverables', options) as WsSalesSolutionDeliverableClass[] | undefined;
          if (del) {
            itemChildren.push(...del);
          }

          // workProducts
          const wor = getItems(data, item.id, 'workProducts', options) as WsSalesSolutionWorkProductClass[] | undefined;
          if (wor) {
            itemChildren.push(...wor);
          }

          // roles
          const rol = getItems(data, item.id, 'roles', options) as WsSalesSolutionOfferingRoleClass[] | undefined;
          if (rol) {
            itemChildren.push(...rol);
          }

          // tools
          const toolItems = getItems(data, item.id, 'tools', options) as WsSalesSolutionToolClass[] | undefined;
          if (toolItems) {
            itemChildren.push(...toolItems);
          }

          // risks
          const riskItems = getItems(data, item.id, 'risks', options) as WsSalesSolutionRiskClass[] | undefined;
          if (riskItems) {
            itemChildren.push(...riskItems);
          }

          (item as WsSalesSolutionAction).children = itemChildren;

        }

        // actions
        (item as WsSalesSolutionItem | WsSalesSolutionAction).actions = getItems(data, item.id, 'actions', options) as WsSalesSolutionAction[];

        // dependencies
        (item as WsSalesSolutionItem | WsSalesSolutionAction).dependencies = getItems(data, item.id, 'dependencies', options) as WsSalesSolutionDependency[];

        // assumptions
        (item as WsSalesSolutionItem | WsSalesSolutionAction).assumptions = getItems(data, item.id, 'assumptions', options) as WsSalesSolutionAssumption[];
      }


      items.push(item);
    }

  });


  if (items.length > 0) {
    return items;
  } else {
    return undefined;
  }
};




// tranform data to items

const salesOfferingsTransformDataToItems = (unknownData: any, options: { mode?: string, selectActions?: boolean }): WsSalesSolutionItem[] => {

  if (unknownData && unknownData['$version'] === '3.0') {

    const data: WsSalesOfferingsData = unknownData;

    // if (options.mode === 'admin') {
    //   const offering = data.offerings.find((o) => o.areaId === '01H7YP9ABD1VPEPS42GQF10W87');
    //   console.log('OFFERINGS');
    //   console.log(offering);
    //   console.log('OFFERINGS');

    //   if (offering) {
    //   } else {
    //     console.log(data.offerings);

    //     data.offerings.splice(31, 0, {
    //       areaId: "01H7YP9ABD1VPEPS42GQF10W87",
    //       id: "01H7YPT54GZKS9F7769KAVS5RR",
    //       name: "Productivity",
    //       parentId: ""
    //     });

    //     console.log(data.offerings);
    //   }
    // }

    const items: WsSalesSolutionItem[] = getItems(data, '', 'offerings', options) as WsSalesSolutionItem[]; // TODO: remove 'as'

    if (items) {
      return items;
    } else {
      return [];
    }

  } else {

    if (unknownData && unknownData.items && Array.isArray(unknownData.items)) {
      return unknownData.items;

    } else {
      return [];
    }
  }
};




export {
  salesOfferingsTransformItemsToData as salesOfferingsTransformItems,
  salesOfferingsTransformDataToItems as salesOfferingsTransformData
};
